<section role="region" aria-labelledby="h2Trades">
  <!-- Token: Trades -->
  <div class="sectionHeader" [ngClass]="{ hidden: !isMobile }">
    <h2 id="h2Trades">
      {{ 'k000132' | translate }}
    </h2>
  </div>

  <div>
    <div class="flex-container-row card-white mb-4 margen1"><!--flex-container-row-->
  <div class="flex-container-row col-xs-12 col-md-12"><!--flex-container-row-->
    <mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <div>
          <button mat-button color="primary">
            <fa-icon [icon]="panelOpenState ? fasSlidersH : farSlidersH"></fa-icon>
            <span class="ml-2" [ngClass]="{'bold': panelOpenState === true}">{{ 'k000317' | translate }}</span>
          </button>
        </div>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>

        <mat-select
          [(value)]="selectedProductName"
          placeholder="{{ 'k001816' | translate }}"
          (selectionChange)="selectChange($event)"
          class="mb-3 col-xs-12 col-md-4 overflow-ellipsis inline-flex"
        >
          <!-- Token: Todos los productos -->
          <mat-option [value]="0">{{ 'k001816' | translate }}</mat-option>
          <!-- Token: Todos los productos -->
          <mat-option
            *ngFor="let product of productNamesFilter"
            [value]="product.ProductName"
            >{{ product.ProductName }}
          </mat-option>
        </mat-select>
        <mat-select
          [(value)]="selectedTrade"
          placeholder="{{ 'k001817' | translate }}"
          (selectionChange)="selectChange($event)"
          class="mb-3 col-xs-12 col-md-2"
        ><!-- class="mb-3 col-xs-12 col-md-3"-->
          <!-- Token: Todos los tipos -->
          <mat-option [value]="0">{{ 'k001817' | translate }}</mat-option>
          <!-- Token: Todos los tipos -->
          <mat-option
            *ngFor="let trade of tradeNamesFilter"
            [value]="trade.TradeName"
            >{{ trade.TradeName }}
          </mat-option>
        </mat-select>
        <!--New ADV-11472 Seleccionar fechas-->
        <div class="otro" (click)="openDialog(periodInitialDate, periodEndDate)">
          <fa-icon class="color" [icon]="['fal', 'calendar']"> </fa-icon>
          <mat-label> {{ 'k000135' | translate }} {{this.periodInitialDate | date : dateFormat}}  {{ 'k000136' | translate }}  {{this.periodEndDate | date : dateFormat}}</mat-label>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </div>
  <tech-loading-peq class="flex-container-row w-100" *ngIf="loadingTrades">
  </tech-loading-peq>

  <div class="flex-container-row w-100" *ngIf="!loadingTrades">
    <div *ngIf="dataTrades.length > 0; else elseBlock">
    <div *ngFor="let item of dataTrades; let i = index">
      <div class="time-stamp">{{ item.groupDate }}</div>
      <tech-datagrid-trades
        class="flex-container-row w-100"
        [dataSource]="item.data"
        #tablePositions
      ></tech-datagrid-trades>

    </div>
    </div>
    <div
        class="w-100 boxSeeAll"
        *ngIf="tableMoreOfTen"
        (click)="panelOpened($event)">
        <div class="w-100 text-center d-block">
          {{ 'k001807' | translate }}
          <!-- //Token: Ver todas -->
          <fa-icon icon="angle-down"></fa-icon>
        </div>
    </div>
  </div>
</div>
<ng-template #elseBlock>
  <div class="table-grid-nodata">
    <span>{{ 'k002559' | translate }}</span>
  </div>
</ng-template>
</div>
</section>
